import { render, staticRenderFns } from "./seedling-overview.vue?vue&type=template&id=476b06a2&scoped=true&"
import script from "./seedling-overview.vue?vue&type=script&lang=js&"
export * from "./seedling-overview.vue?vue&type=script&lang=js&"
import style0 from "./seedling-overview.vue?vue&type=style&index=0&id=476b06a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476b06a2",
  null
  
)

export default component.exports